var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "layout",
    {
      attrs: {
        settings: _vm.settings,
        "is-loading": _vm.isSavingWizardPageAnswer,
        "custom-class-name": _vm.layoutCustomClassName,
      },
      on: {
        restart: _vm.onRestartWizard,
        "go-to-landing-page": _vm.showLandingPage,
        prev: _vm.onPrev,
        next: _vm.onNext,
        skip: _vm.onSkip,
        "load-more-products": _vm.onLoadMoreProducts,
        "progress-bar-item-click": _vm.onProgressBarItemClick,
        search: _vm.onSearch,
        "link-from-message-click": _vm.onClickLinkFromMessage,
      },
    },
    [
      _vm.showSpinner ? _c("spinner") : _vm._e(),
      _vm._v(" "),
      !_vm.showSpinner &&
      _vm.currentWizardPage &&
      !_vm.isCurrentProductsPage &&
      _vm.wizardPageData
        ? _c("wizard-page", {
            attrs: {
              question: _vm.currentWizardPage,
              "question-data": _vm.wizardPageData,
              selections: _vm.selectedOptions,
              "show-spinner": _vm.showSpinner,
              "option-search-query": _vm.optionSearchQuery,
            },
            on: { select: _vm.onSelectQuestion },
          })
        : _vm._e(),
      _vm._v(" "),
      !_vm.showSpinner && _vm.currentWizardPage && _vm.isCurrentProductsPage
        ? _c("wizard-page-products", { on: { restart: _vm.onRestartWizard } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }